<template>
  <div v-if="value" class="recommended-filter-modal" @click.self="$emit('close')">
    <section class="recommended-filter-card" role="dialog" aria-modal="true">
      <header class="recommended-filter-card--header">
        <div>
          <h3>Filter listing rekomendasi</h3>
          <p>Pilih detail listing dan periode yang ingin ditampilkan.</p>
        </div>

        <button type="button" aria-label="Tutup filter" @click="$emit('close')">
          <v-icon size="21">mdi-close</v-icon>
        </button>
      </header>

      <div class="recommended-filter-panel">
        <div class="recommended-filter-field">
          <span>Tipe properti</span>

          <multiselect
            v-model="selectedPropertyType"
            :options="propertyTypes"
            track-by="id"
            label="name"
            placeholder="Semua tipe"
            select-label=""
            deselect-label=""
            :show-labels="false"
            :allow-empty="true"
            class="recommended-filter-select"
          />
        </div>

        <div class="recommended-filter-field">
          <span>Periode waktu</span>

          <multiselect
            v-model="selectedPeriodStart"
            :options="periodOptions"
            track-by="value"
            label="label"
            placeholder="Semua periode"
            select-label=""
            deselect-label=""
            :show-labels="false"
            :allow-empty="true"
            class="recommended-filter-select"
          />
        </div>

        <div class="recommended-filter-field">
          <span>Tipe listing</span>

          <multiselect
            v-model="selectedListingType"
            :options="listingTypeOptions"
            track-by="value"
            label="label"
            placeholder="Semua tipe"
            select-label=""
            deselect-label=""
            :show-labels="false"
            :allow-empty="true"
            class="recommended-filter-select"
          />
        </div>

        <div class="recommended-filter-field">
          <span>Provinsi</span>

          <multiselect
            v-model="selectedProvince"
            :options="provinces"
            track-by="id"
            label="name"
            placeholder="Pilih provinsi"
            select-label=""
            deselect-label=""
            :show-labels="false"
            :allow-empty="true"
            class="recommended-filter-select"
            @input="$emit('change-province', $event)"
          />
        </div>

        <div v-if="province" class="recommended-filter-field">
          <span>Kota</span>

          <multiselect
            v-model="selectedCity"
            :options="cities"
            track-by="id"
            label="name"
            placeholder="Pilih kota"
            select-label=""
            deselect-label=""
            :show-labels="false"
            :allow-empty="true"
            class="recommended-filter-select"
            @input="$emit('change-city', $event)"
          />
        </div>

        <div v-if="city" class="recommended-filter-field">
          <span>Area</span>

          <multiselect
            v-model="selectedArea"
            :options="areas"
            track-by="id"
            label="name"
            placeholder="Pilih area"
            select-label=""
            deselect-label=""
            :show-labels="false"
            :allow-empty="true"
            class="recommended-filter-select"
          />
        </div>
      </div>

      <footer class="recommended-filter-card--footer">
        <button type="button" class="recommended-filter-clear" @click="$emit('clear')">
          <v-icon size="18">mdi-filter-remove-outline</v-icon>
          <span>Reset filter</span>
        </button>

        <button type="button" class="recommended-filter-apply" @click="$emit('apply')">
          Terapkan
        </button>
      </footer>
    </section>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

require('vue-multiselect/dist/vue-multiselect.min.css');

export default {
  name: 'recommended-listing-filter-modal',

  components: {
    Multiselect,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },

    propertyTypes: {
      type: Array,
      default: () => [],
    },

    periodOptions: {
      type: Array,
      default: () => [],
    },

    listingTypeOptions: {
      type: Array,
      default: () => [],
    },

    provinces: {
      type: Array,
      default: () => [],
    },

    cities: {
      type: Array,
      default: () => [],
    },

    areas: {
      type: Array,
      default: () => [],
    },

    propertyType: {
      type: Object,
      default: null,
    },

    periodStart: {
      type: Object,
      default: null,
    },

    listingType: {
      type: Object,
      default: null,
    },

    province: {
      type: Object,
      default: null,
    },

    city: {
      type: Object,
      default: null,
    },

    area: {
      type: Object,
      default: null,
    },
  },

  computed: {
    selectedPropertyType: {
      get() {
        return this.propertyType;
      },
      set(value) {
        this.$emit('update:property-type', value);
      },
    },

    selectedPeriodStart: {
      get() {
        return this.periodStart;
      },
      set(value) {
        this.$emit('update:period-start', value);
      },
    },

    selectedListingType: {
      get() {
        return this.listingType;
      },
      set(value) {
        this.$emit('update:listing-type', value);
      },
    },

    selectedProvince: {
      get() {
        return this.province;
      },
      set(value) {
        this.$emit('update:province', value);
      },
    },

    selectedCity: {
      get() {
        return this.city;
      },
      set(value) {
        this.$emit('update:city', value);
      },
    },

    selectedArea: {
      get() {
        return this.area;
      },
      set(value) {
        this.$emit('update:area', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/utils/variables';

$brand-red: #c81919;
$brand-red-soft: #ffffff;

$neutral-950: #18181b;
$neutral-800: #27272a;
$neutral-700: #3f3f46;
$neutral-500: #71717a;
$neutral-400: #a1a1aa;
$neutral-150: #ececee;
$neutral-50: #fafafa;

.recommended-filter-modal {
  position: fixed;
  z-index: 60;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 22px;
  background: rgba(24, 24, 27, 0.42);
  inset: 0;
}

.recommended-filter-card {
  width: 100%;
  max-width: 680px;
  max-height: calc(100vh - 44px);
  margin: auto;
  overflow: visible;
  border: 1px solid $neutral-150;
  border-radius: 22px;
  background: $color-white;
  box-shadow: 0 24px 70px rgba(24, 24, 27, 0.24);
}

.recommended-filter-card--header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 22px 24px 16px;
  border-bottom: 1px solid $neutral-150;
  gap: 18px;

  h3 {
    margin: 0 0 5px;
    color: $neutral-950;
    font-family: Poppins-Bold, sans-serif;
    font-size: 20px;
    line-height: 1.35;
  }

  p {
    margin: 0;
    color: $neutral-500;
    font-family: Poppins-Regular, sans-serif;
    font-size: 14px;
    line-height: 1.55;
  }

  button {
    display: inline-flex;
    width: 38px;
    height: 38px;
    flex: 0 0 38px;
    align-items: center;
    justify-content: center;
    border: 1px solid $neutral-150;
    border-radius: 12px;
    background: $neutral-50;

    .v-icon {
      color: $neutral-700;
    }
  }
}

.recommended-filter-panel {
  display: grid;
  min-width: 0;
  padding: 20px 24px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.recommended-filter-field {
  min-width: 0;

  > span {
    display: block;
    margin: 0 0 6px 2px;
    color: $neutral-500;
    font-family: Poppins-SemiBold, sans-serif;
    font-size: 11px;
    line-height: 1.2;
  }
}

.recommended-filter-select {
  min-height: 42px;

  ::v-deep .multiselect__tags {
    min-height: 42px;
    padding: 10px 36px 0 12px;
    border: 1px solid $neutral-150;
    border-radius: 12px;
    background: $color-white;
  }

  ::v-deep .multiselect__single,
  ::v-deep .multiselect__placeholder,
  ::v-deep .multiselect__input {
    overflow: hidden;
    margin-bottom: 0;
    color: $neutral-800;
    font-family: Poppins-Regular, sans-serif;
    font-size: 13px;
    line-height: 21px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ::v-deep .multiselect__placeholder {
    color: $neutral-400;
  }

  ::v-deep .multiselect__select {
    height: 40px;
  }

  ::v-deep .multiselect__content-wrapper {
    border-color: $neutral-150;
    border-radius: 0 0 12px 12px;
    box-shadow: 0 12px 24px rgba(24, 24, 27, 0.1);
  }

  ::v-deep .multiselect__option {
    min-height: 36px;
    padding: 10px 12px;
    font-family: Poppins-Regular, sans-serif;
    font-size: 13px;
  }

  ::v-deep .multiselect__option--highlight {
    background: $brand-red;
  }
}

.recommended-filter-clear {
  display: inline-flex;
  min-width: 0;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  align-self: end;
  padding: 0 12px;
  border: 1px solid rgba(200, 25, 25, 0.18);
  border-radius: 12px;
  color: $brand-red;
  background: $brand-red-soft;
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 13px;
  gap: 7px;

  .v-icon {
    color: $brand-red;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
}

.recommended-filter-card--footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px 22px;
  border-top: 1px solid $neutral-150;
  gap: 12px;
}

.recommended-filter-apply {
  display: inline-flex;
  min-height: 42px;
  min-width: 128px;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  border: 0;
  border-radius: 12px;
  color: $color-white;
  background: $brand-red;
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 14px;
}

@media (max-width: 767px) {
  .recommended-filter-panel {
    grid-template-columns: minmax(0, 1fr);
    padding: 16px;
  }

  .recommended-filter-modal {
    align-items: center;
    padding: 18px 14px;
  }

  .recommended-filter-card {
    max-height: calc(100vh - 36px);
    overflow-y: auto;
    border-radius: 18px;
  }

  .recommended-filter-card--header {
    padding: 18px 18px 14px;

    h3 {
      font-size: 18px;
    }
  }

  .recommended-filter-card--footer {
    flex-direction: column-reverse;
    align-items: stretch;
    padding: 14px 16px 18px;
  }

  .recommended-filter-clear,
  .recommended-filter-apply {
    width: 100%;
  }
}
</style>
